import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useStore } from "react-redux";
import { decodeBrowserPathToState } from "../common/actions";

export const useQuerySyncEffect = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const store = useStore();

  useEffect(() => {
    dispatch(decodeBrowserPathToState(store, location.search || "") as any);
  }, [location.pathname, location.search, dispatch, store]);
};
